import { getMySurvey } from '../../services/data-entry/surveys.service';

export const UPDATE_SURVEY_TO_FILL_DATA = 'UPDATE_SURVEY_TO_FILL_DATA';
export const UPDATE_SURVEY_TO_FILL_QUESTION = 'UPDATE_SURVEY_TO_FILL_QUESTION';
export const TOGGLE_LOADING_SURVEY_TO_FILL = 'TOGGLE_LOADING_SURVEY_TO_FILL';
export const SURVEY_TO_FILL_ERROR = 'SURVEY_TO_FILL_ERROR';
export const SURVEY_TO_FILL_RESET_ERRORS = 'SURVEY_TO_FILL_RESET_ERRORS';
export const SURVEY_TO_FILL_RESET_STATE = 'SURVEY_TO_FILL_RESET_STATE';

export const updateSurveyToFillData = (value = {}) => ({
  type: UPDATE_SURVEY_TO_FILL_DATA,
  payload: { name: 'data', value }
});

export const updateSurveyToFillQuestion = (value = {}) => ({
  type: UPDATE_SURVEY_TO_FILL_QUESTION,
  payload: { name: 'value', value }
});

export const surveyToFillError = (value = null) => ({
  type: SURVEY_TO_FILL_ERROR,
  payload: { name: 'error', value }
});

export const toggleLoadingSurveyToFill = (value = false) => ({
  type: TOGGLE_LOADING_SURVEY_TO_FILL,
  payload: { name: 'loading', value }
});

export const resetSurveyToFillErrors = () => ({
  type: SURVEY_TO_FILL_RESET_ERRORS,
  payload: {}
});

export const resetSurveyToFillState = () => ({
  type: SURVEY_TO_FILL_RESET_STATE,
  payload: {}
});

export const prepateData = (data = {}) => {
  const newData = { ...data };
  const { template = {}, answers = [] } = data;
  const newTemplate = { ...template };

  newTemplate.questions = newTemplate.questions.map((question) => {
    const { id } = question;
    const answer = answers.find((a) => a.questionId === id);
    question.answer = answer?.answer || [];
    question.error = null;
    return question;
  });

  newData.template = newTemplate;

  return newData;
};

export const loadSurveyDataToFill = (surveyId = '') => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingSurveyToFill(true));
      dispatch(surveyToFillError());

      const { data: requestData } = await getMySurvey(surveyId);
      const data = prepateData(requestData);

      if (data) {
        dispatch(updateSurveyToFillData(data));
        return;
      } else {
        dispatch(updateSurveyToFillData(null));
      }
    } catch (error) {
      dispatch(updateSurveyToFillData(null));
    } finally {
      dispatch(toggleLoadingSurveyToFill());
      dispatch(surveyToFillError());
    }
  };
};
